import { Card } from '@/components/layout/Card';

interface MetricCardProps {
  label: string;
  value: string;
}

/**
 * Metric summary card used in the dashboard header row.
 */
export function MetricCard({ label, value }: MetricCardProps) {
  return (
    <Card className="p-[24px]">
      <p className="text-[#8d8c8f] text-[14px] mb-[8px] font-medium">{label}</p>
      <p className="text-[#181818] text-[36px] font-semibold leading-none">{value}</p>
    </Card>
  );
}
